export const CHAT_STATUS = {
  STREAMING: "streaming",
  SUBMITTED: "submitted",
} as const;
